// Native disclosures remain functional without this keyboard convenience.
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const details = event.target.closest('details[open]');
  if (details) { details.open = false; details.querySelector('summary').focus(); }
});
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-purchase-link]');
  if (!link) return;
  const details = document.querySelector('[id^="ProductDetails-"]');
  if (details) {
    event.preventDefault();
    details.scrollIntoView({ block: 'start', behavior: 'auto' });
    details.focus({ preventScroll: true });
  }
});
document.addEventListener('shopify:block:select', (event) => {
  const disclosure = event.target.closest('details') || event.target.querySelector('details');
  if (disclosure) disclosure.open = true;
});
document.addEventListener('shopify:section:load', (event) => {
  window.Shopify?.PaymentButton?.init();
  event.target.querySelector('product-info')?.syncState(true);
});
